import { render, staticRenderFns } from "./withdrawal-records.vue?vue&type=template&id=4f0a7904&scoped=true&"
import script from "./withdrawal-records.vue?vue&type=script&lang=js&"
export * from "./withdrawal-records.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-records.vue?vue&type=style&index=0&id=4f0a7904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a7904",
  null
  
)

export default component.exports